import KeyedAndNamedDto from 'modules/base/dto/KeyedAndNamedDto';
import FmFileCategoryType from './FmFileCategoryType';

export class FmBrowserTableDto extends KeyedAndNamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.fileName = null;
		/** @type {string} */
		this.fileCategory = null;
		/** @type {Date} */
		this.fileModified = null;
		/** @type {number} */
		this.fileSize = null;
	}

	/**
	 * @typedef {Object} _FmBrowserTableDtoProps
	 * @property {string} fileName
	 * @property {string} fileCategory
	 * @property {Date} fileModified
	 * @property {number} fileSize
	 * @typedef {import("../KeyedAndNamedDto").KeyedAndNamedDtoProps & _FmBrowserTableDtoProps} FmBrowserTableDtoProps
	 */
	/**
	 *
	 * @param {FmBrowserTableDtoProps} props
	 * @returns {FmBrowserTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.fileName = props.fileName;
		this.fileCategory = props.fileCategory;
		this.fileModified = props.fileModified ? new Date(props.fileModified) : null;
		this.fileSize = props.fileSize;
		return this;
	}

	/**
	 *
	 * @param {string} key
	 * @returns {string}
	 */
	getAsString(key) {
		if (key === 'fileCategory') {
			return this.fileCategory ? FmFileCategoryType[this.fileCategory] : '';
		}
		return super.getAsString(key);
	}
}

export default FmBrowserTableDto;
